/**
 * CK | Buy Button JS – Fast Bundle Edition
 *
 * Vereinfachte Version: Kein Varianten-Tracking mehr.
 * Preis-Updates kommen von ck-product-custom-variants.js via syncBuyButtonPrice.
 * Slide-down Garantie-Details bleiben erhalten.
 */
(() => {
  'use strict';

  const init = (root) => {
    if (!root || root.dataset.ckInit === 'true') return;
    root.dataset.ckInit = 'true';

    // Slide-down guarantee details
    const toggle = root.querySelector('[data-ck-buy-button-toggle]');
    const content = root.querySelector('[data-ck-buy-button-content]');

    const setOpen = (isOpen) => {
      if (!content || !toggle) return;
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      content.style.maxHeight = isOpen ? `${content.scrollHeight}px` : '0px';
    };

    if (toggle && content) {
      setOpen(false);
      toggle.addEventListener('click', () => {
        setOpen(toggle.getAttribute('aria-expanded') !== 'true');
      });
      window.addEventListener('resize', () => {
        if (toggle.getAttribute('aria-expanded') === 'true') setOpen(true);
      });
    }
  };

  const boot = () => {
    document.querySelectorAll('[data-ck-buy-button]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
